module.exports = __webpack_public_path__ + "static/media/book-heart.af779534.svg";